import { StyleSheet, Dimensions } from 'react-native';

import { Colors } from '@vfgroup-oneplatform/foundation/Components/Themes';

const { width: screenWidth, height: screenHeight } = Dimensions.get('window');

export default StyleSheet.create({
  backdrop: {
    position: 'absolute',
    backgroundColor: Colors.overlay,
    bottom: 0,
    width: screenWidth,
    height: screenHeight * 2,
  },
  innerBackOverlay: {
    flex: 1,
  },
});
